// extracted by mini-css-extract-plugin
module.exports = {"scannerCards":"receipt-document-scanners_scannerCards__Oc4XW","scannerCard":"receipt-document-scanners_scannerCard__P_ATe"};